import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { flex, stack } from '@flipster/styled-system/patterns';

import { BrtNodeNoContext, brtBunja } from '../state';
import { NodeDetails } from './node-details';
import { TopBar } from './top-bar';
import { TreeView } from './treeview';

export const Brt = () => {
  const { selectedNoAtom } = useBunja(brtBunja);
  const selectedNo = useAtomValue(selectedNoAtom);
  return (
    <div
      className={stack({
        minH: '100%',
        maxH: '100%',
        flex: 1,
        rounded: 4,
        overflow: 'hidden',
        bgColor: 'background.default.level-0',
      })}
    >
      <TopBar />
      <div className={flex({ flex: 1, gap: 8, minH: 0, h: 0 })}>
        <TreeView />
        {selectedNo > 0 && (
          <BrtNodeNoContext value={selectedNo}>
            <NodeDetails />
          </BrtNodeNoContext>
        )}
      </div>
    </div>
  );
};
